import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import axios, { AxiosResponse } from 'axios';

import s from './Text.module.scss';

function Text({ path }: { path: string }) {
  const [text, setText] = useState('');

  useEffect(() => {
    setText('');

    axios.get(path)
      .then((res: AxiosResponse<string>) => {
        if (res) setText(res.data);
      })
      .catch();
  }, [path]);

  return (
    <>
      <div className={cx('container', 'inner-pages')}>
        <div className={s.Wrapper}>
          <div dangerouslySetInnerHTML={{ __html: text }} />
        </div>
      </div>
    </>
  );
}

export default Text;
